/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = CheckedIn
 *
 * 1 = InProgress
 *
 * 2 = PausedAwaitingAuthority
 *
 * 3 = PausedTechnicalSupport
 *
 * 4 = PausedWaitingForParts
 *
 * 5 = Completed
 *
 * 6 = ReadyForCollection
 *
 * 7 = PartsOrderedOffSite
 *
 * 8 = PartsOrderedOnSite
 *
 * 9 = JobAuthorised
 *
 * 10 = СollectedNotInvoiced
 */
export enum WIPStatusEnum {
  CheckedIn = 0,
  InProgress = 1,
  PausedAwaitingAuthority = 2,
  PausedTechnicalSupport = 3,
  PausedWaitingForParts = 4,
  Completed = 5,
  ReadyForCollection = 6,
  PartsOrderedOffSite = 7,
  PartsOrderedOnSite = 8,
  JobAuthorised = 9,
  СollectedNotInvoiced = 10,
}
